/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import TrackBall from './TrackBall';

export default class TrackBalls extends Phaser.GameObjects.Container {
  constructor(scene, track, layers, nums) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.isComplete = false;
    this.layers = layers;
    this.bonusColors = [];
    this.ballSize = gameData.BALL_SIZE;
    this.moveSpeed = gameData.BALL_SPEED;
    this.targetNum = gameData.addNum;
    this.trackRef = track;
    this.ballsRemaining = 30;
    this.startAmt = 10;
    this.startDistance = 0;
    this.multiplier = 1;
    this.ballValues = nums;

    // init with start balls
    this.balls = [];
    while (this.balls.length < this.startAmt) {
      const b = new TrackBall(this.scene, this.ballValues[Phaser.Math.Between(0,this.ballValues.length - 1)], Phaser.Math.Between(1,8));

      b.curDistance = 0;
      b.curDepth = 0;
      b.bouncing = false;
      this.balls.push(b);
      const container = this.layers[0].layerContainer;

      b.parentContainer?.remove(b);
      container.add(b);

      this.ballsRemaining--;
      this.scene.time.delayedCall(100 * this.balls.length, () => {this.slideIn();});
    }
  }

  // slide sounds, messy but quick
  slideIn() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cartoon_slide_flip, this.scene);
  };

  moveBalls() {
    this.startDistance += this.moveSpeed;

    if (this.startDistance >= this.ballSize && this.ballsRemaining > 0) {
      this.startDistance = 0;

      // pick random value and color first so bonus values will clear properly
      const b = new TrackBall(this.scene, this.ballValues[Phaser.Math.Between(0,this.ballValues.length - 1)],Phaser.Math.Between(1,8));
      if (this.bonusColors.length > 0) {
        const bVal = this.bonusColors[Phaser.Math.Between(0,1)];
        b.changeBall(bVal.val,bVal.colorId);
      }

      b.curDistance = 0;
      b.curDepth = 0;
      b.bouncing = false;
      const container = this.layers[0].layerContainer;

      b.parentContainer?.remove(b);
      container.add(b);
      this.balls.unshift(b);
      this.ballsRemaining--;
    }

    for (let i = 0; i < this.balls.length; i++) {
      const ball = this.balls[i];
      const targetDistance = this.startDistance + (i * this.ballSize);

      if (targetDistance > this.trackRef.totalLineLength) {
        this.emit('TRACK_END', false);
        break;
      }
      else {
        const startDistance = ball.curDistance;

        let trackData;
        if (startDistance < targetDistance - (this.moveSpeed * 20)) {// behind
          const behindDistance = startDistance + (this.moveSpeed * 20);
          trackData = this.trackRef.getEvenTrackPoint(behindDistance);
          ball.x = trackData.curvePt.x;
          ball.y = trackData.curvePt.y;
          ball.curDistance = behindDistance;
        }
        else if (startDistance - (this.moveSpeed * 20) > targetDistance) {//
          const forwardDistance = startDistance - (this.moveSpeed * 20);
          trackData = this.trackRef.getEvenTrackPoint(forwardDistance);

          ball.x = trackData.curvePt.x;
          ball.y = trackData.curvePt.y;
          ball.curDistance = forwardDistance;
        }
        else {
          if (ball.bouncing === true) {

            ball.bouncing = false;
            const bounceOff = this.balls[i - 1];
            if (bounceOff) {
              if (ball.numValue + bounceOff.numValue === gameData.addNum) {
                this.multiplier *= 2;
                this.scoreHit(ball);
              }
              else {
                this.multiplier = 1;
              }
            }
            else {
              this.multiplier = 1;
            }
          }

          trackData = this.trackRef.getEvenTrackPoint(targetDistance);
          ball.x = trackData.curvePt.x;
          ball.y = trackData.curvePt.y;
          ball.curDistance = this.trackRef.getStoredDistance(trackData.pathSegIndex,trackData.curveSegIndex);
        }

        let h = 0;
        while (this.layers[h].end < ball.curDistance && this.layers[h].end !== 'total') {
          h++;

        }
        ball.curDepth = h;
        if (ball.parentContainer !== this.layers[h].layerContainer && ball.numValue !== 0) {
          ball.parentContainer?.remove(ball);
          this.layers[h].layerContainer.add(ball);
        }
      }
    }
  };

  setBonusValues(vals) {
    this.bonusColors = vals;
    for (let j = 0; j < this.balls.length; j++) {
      const ball = this.balls[j];
      const defaultChoice = { val: ball.defaultValue,colorId: ball.defaultStyle };
      const choice = this.bonusColors.length === 0 ? defaultChoice : this.bonusColors[Phaser.Math.Between(0,1)];
      if (ball.changeBall) ball.changeBall(choice.val,choice.colorId);
    }
  };

  checkHit(shot) {
    // check falling?
    const shotPosX = shot.x;
    const shotPosY = shot.y;
    let hit = false;

    for (let i = 0; i < this.balls.length; i++) {
      const b = this.balls[i];

      // check position overlap
      if (b.numValue !== 0) {
        const bX = b.x;
        const bY = b.y;
        const distY = bY - shotPosY;
        const distX = bX - shotPosX;
        const dist = Math.sqrt((distX * distX) + (distY * distY));
        if (dist <= this.ballSize && shot.isHit === false) {
          // check pixel collision to not balls under overlap?
          const dist = Phaser.Math.Distance.Between(b.x, b.y, shot.x, shot.y);
          const threshold = b.getBounds().width / 2;

          if (dist <= threshold) {
            shot.isHit = true;
            shot.curDepth = 0;
            shot.bouncing = false;
            this.handleHit(shot,b);
            hit = true;

            this.emit('TRACK_HIT', shot);
            break;
          }
        }
        if (hit === true) break;
      }
    }
  };

  handleHit(shot, hitBall) {
    const hitIndex = this.balls.indexOf(hitBall);

    const lowerX = hitIndex === 0 ? 0 : this.balls[hitIndex - 1].x;
    const lowerY = hitIndex === 0 ? 0 : this.balls[hitIndex - 1].y;
    const higherX = hitIndex === this.balls.length - 1 ? this.balls[this.balls.length - 1].x + this.ballSize : this.balls[this.balls.length - 1].x;
    const higherY = hitIndex === this.balls.length - 1 ? this.balls[this.balls.length - 1].y + this.ballSize : this.balls[this.balls.length - 1].y;

    const dist1X = shot.x - lowerX;
    const dist1Y = shot.y - lowerY;
    const dist1 = Math.sqrt((dist1X * dist1X) + (dist1Y * dist1Y));
    const dist2X = shot.x - higherX;
    const dist2Y = shot.y - higherY;
    const dist2 = Math.sqrt((dist2X * dist2X) + (dist2Y * dist2Y));
    const addIndex = this.getHighestNum([dist1,dist2]) === dist1 ? hitIndex + 1 : hitIndex;

    shot.angle = 0;

    const trackData = this.trackRef.getEvenTrackPoint(this.startDistance + (addIndex * this.ballSize));
    const endX = trackData.curvePt.x;
    const endY = trackData.curvePt.y;

    const holder = this.scene.add.container();
    holder.x = endX;
    holder.y = endY;
    holder.numValue = 0;
    holder.bouncing = false;
    const holderDist = this.startDistance + (addIndex * this.ballSize);

    this.balls.splice(addIndex,0,holder);

    let h = 0;
    while (this.layers[h].end < holderDist && this.layers[h].end !== 'total') {
      h++;
    }
    holder.curDepth = h;

    ABCyaPhaser.Tweens.addTween(shot, 200, { x: endX, y: endY }, Phaser.Math.Easing.Linear, () => {
      this.shiftIn(shot, holder);
    });
  };

  getHighestNum(arr) {
    let num = 0;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] > num) num = arr[i];
    }
    return num;
  }

  shiftIn(ball,holder) {
    ball.parentContainer?.remove(ball);
    this.layers[ball.curDepth].layerContainer.add(ball);
    this.balls[this.balls.indexOf(holder)] = ball;

    this.scoreHit(ball);
  };

  scoreHit(ball) {
    let points = 0;
    const hitX = ball.x;
    const hitY = ball.y;
    const ballsToRemove = [];

    while (this.balls.indexOf(ball) > 0 && (this.balls[this.balls.indexOf(ball) - 1].numValue * ball.numValue === gameData.addNum || this.balls[this.balls.indexOf(ball) - 1].numValue === 0)) {
      const hitBall = this.balls[this.balls.indexOf(ball) - 1];
      this.balls.splice(this.balls.indexOf(ball) - 1,1);
      if (hitBall.numValue !== 0) {

        points += 10 * this.multiplier;
      }

      ballsToRemove.unshift(hitBall);
    }

    while (this.balls.indexOf(ball) < this.balls.length - 1 && (this.balls[this.balls.indexOf(ball) + 1].numValue * ball.numValue === gameData.addNum || this.balls[this.balls.indexOf(ball) + 1].numValue === 0)) {
      const hitBall2 = this.balls[this.balls.indexOf(ball) + 1];
      this.balls.splice(this.balls.indexOf(ball) + 1,1);
      if (hitBall2.numValue !== 0) points += 10 * this.multiplier;
      ballsToRemove.push(hitBall2);
    }

    if (points > 0) {
      // match loose ends here???
      const spaceIndex = this.balls.indexOf(ball);
      if (spaceIndex < this.balls.length - 1) {
        const fallingBall = this.balls[spaceIndex + 1];
        fallingBall.bouncing = true;
      }

      points += 10 * this.multiplier;
      this.balls.splice(this.balls.indexOf(ball),1);
      this.removeBall(ball,false);

      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cartoon_pop, this.scene);

      this.emit('GET_POINTS', points, hitX, hitY);
    }
    else {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cartoon_double_pop_fast, this.scene);
    }

    const rLen = ballsToRemove.length;
    while (ballsToRemove.length > 0) {
      const rBall = ballsToRemove.shift();
      const extraSound = rLen !== 1;

      this.scene.time.delayedCall((rLen - ballsToRemove.length) * 100, () => {
        this.removeBall(rBall,extraSound);
      });
    }

    if (this.balls.length === 0 && this.ballsRemaining <= 0) {
      // trigger end
      this.emit('TRACK_END', true);
    }
  };

  removeBall(ball,extra) {
    if (this.multiplier === 1 && extra === false) {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cartoon_pop, this.scene);
    }
    else {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._extra_points, this.scene);
    }

    ABCyaPhaser.Tweens.addTween(ball, 800, { alpha: 0, scale: 1.5 }, Phaser.Math.Easing.Bounce.Out, () => {
      ball.destroy();
    });
  };
}